export default __webpack_public_path__ + "static/media/bama.1ad64071.jpg";